import React, { useState, useEffect } from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faLock } from '@fortawesome/free-solid-svg-icons';

import './ForceChangePassword.css';
import { sendAsyncRequest, loadAuthorities } from '../../services/AsyncRequestService';
import { cognitoLoginSuccess } from '../../services/AuthService';

import logo from "../../assets/images/RM Logo=Reversed.png";

import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';

const ForceChangePassword = () => {
    const location = useLocation();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [cognitoUserSession, setCognitoUserSession] = useState(null);
    const [redirectToReferrer, setRedirectToReferrer] = useState(false);

    useEffect(() => {
        if (location.state?.session && location.state?.email) {
            setCognitoUserSession(location.state.session);
            setEmail(location.state.email);
        }
    }, [location.state]);

    const handleChange = e => {
        const { name, value } = e.target;
        setError("");
        if (name === 'password') {
            setPassword(value);
        } else {
            setConfirmPassword(value);
        }
    }

    const handlePasswordChange = (e) => {
        e.preventDefault();

        if (password !== confirmPassword) {
            setError("Passwords do not match");
            return;
        }

        const data = {
            session: cognitoUserSession,
            newPassword: password,
            email: email
        };

        sendAsyncRequest('/auth/respond-to-auth-challenge', 'POST', data, onPasswordChangeSuccess, onPasswordChangeFailure);
    }

    const onPasswordChangeSuccess = (response) => {
        let data = response.data;
        let userObjToSave = {
          uuid: data.uuid,
          name: data.name,
          authorities: data.authorities,
          email: data.email,
          tableAttributes: data.tableAttributes
        };
        cognitoLoginSuccess(userObjToSave,
            data.commitVersionId,
            data.currentReleaseNumber,
            data.deviceKey,
            data.currentTimeMillis,
            data.idTokenDurationSecs,
            data.csrfToken
        );
        loadAuthorities().finally(() => setRedirectToReferrer(true));
    }

    const onPasswordChangeFailure = (error) => {
        setError("Invalid password. Please try again.");
    }

    if (redirectToReferrer) {
        return <Navigate to="/" replace />;
    }

    if (!location.state?.session) {
        return <Navigate to="/login" replace />;
    }

    return (
        <div className="force-change-password-container">
            <div className="login-page">
                            <Card className="login-card">
                                <Card.Body>
                                    <div className="logo-large">
                                        <img src={logo} alt="Imagine RazorMetrics Logo" style={{ maxWidth: '200px' }} />
                                    </div>
                                    <h3 className="login-title">Create New Password</h3>
                                    {error && <Alert variant="danger">{error}</Alert>}
                                    <Form onSubmit={handlePasswordChange}>
                                        <Form.Group className="form-group">
                                            <div className="input-group">
                                                <span className="input-icon">
                                                    <FontAwesomeIcon icon={faEnvelope} />
                                                </span>
                                                <Form.Control
                                                    type="email"
                                                    name="email"
                                                    value={email}
                                                    readOnly
                                                    className="form-control-with-icon"
                                                />
                                            </div>
                                        </Form.Group>
                                        <Form.Group className="form-group">
                                            <div className="input-group">
                                                <span className="input-icon">
                                                    <FontAwesomeIcon icon={faLock} />
                                                </span>
                                                <Form.Control
                                                    type="password"
                                                    name="password"
                                                    value={password}
                                                    placeholder="Enter new password"
                                                    onChange={handleChange}
                                                    className="form-control-with-icon"
                                                    required
                                                />
                                            </div>
                                        </Form.Group>
                                        <Form.Group className="form-group">
                                            <div className="input-group">
                                                <span className="input-icon">
                                                    <FontAwesomeIcon icon={faLock} />
                                                </span>
                                                <Form.Control
                                                    type="password"
                                                    name="confirmPassword"
                                                    value={confirmPassword}
                                                    placeholder="Confirm new password"
                                                    onChange={handleChange}
                                                    className="form-control-with-icon"
                                                    required
                                                />
                                            </div>
                                        </Form.Group>
                                        <Button type="submit" variant="primary" className="login-button">
                                            Submit
                                        </Button>
                                    </Form>
                                </Card.Body>
                            </Card>
            </div>
        </div>
    );
}

export default ForceChangePassword;
